import AppButton from "../button/button";
import ModalShell from "../modalShell/ModalShell";
import Typography from "../typography/Typography";
import styles from "./confirmDialog.module.scss";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  body?: string;
  primaryLabel: string;
  secondaryLabel: string;
  onPrimary: () => void;
  onSecondary: () => void;
  onClose: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  body,
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  onClose,
}: ConfirmDialogProps): JSX.Element | null {
  return (
    <ModalShell open={open} title={title} onClose={onClose} showClose={Boolean(title)}>
      {body && <Typography className={styles.description}>{body}</Typography>}
      <div className={styles.actionCard}>
        <AppButton variant="newTertiary" onClick={onSecondary} className={styles.btn}>
          {secondaryLabel}
        </AppButton>
        <AppButton onClick={onPrimary} className={styles.btn}>
          {primaryLabel}
        </AppButton>
      </div>
    </ModalShell>
  );
}
